import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const TwoFactorRecoveryCodesIcon = (props: SvgIconProps) => {
    const { white } = colors;

    return (
        <SvgIcon {...props}>
            <svg
                width="144"
                height="144"
                viewBox="0 0 144 144"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_14244_10806)">
                    <path
                        d="M60.7687 108.576C35.7847 103.824 19.2967 79.6321 23.9767 54.6481C28.7287 29.6641 52.9207 13.1761 77.9047 17.8561C97.7767 21.6001 113.113 38.2321 115.201 58.3201L109.369 58.9681C107.497 41.4721 94.1047 26.9281 76.7527 23.6161C54.9367 19.5121 33.7687 33.9121 29.6647 55.7281C25.5607 77.5441 39.9607 98.7121 61.7767 102.816L60.6967 108.576H60.7687Z"
                        fill="#70B8FF"
                    />

                    <path
                        d="M103.32 55.9438L111.888 71.2798L120.888 56.2318L103.32 55.9438Z"
                        fill="#70B8FF"
                    />

                    <path
                        d="M87.8393 62.7119H80.6393V54.5039C80.6393 48.5279 75.7433 43.6319 69.7673 43.6319C63.7913 43.6319 58.8953 48.5279 58.8953 54.5039V62.7119H51.6953V54.5039C51.6953 44.4959 59.8313 36.3599 69.8393 36.3599C79.8473 36.3599 87.9833 44.4959 87.9833 54.5039V62.7119H87.8393Z"
                        fill="url(#paint0_linear_14244_10806)"
                    />

                    <path
                        d="M49.3914 61.9917H89.4954C92.5914 61.9917 95.1114 64.5117 95.1114 67.6077V92.2317C95.1114 102.672 86.6154 111.168 76.1754 111.168H62.7114C52.2714 111.168 43.7754 102.672 43.7754 92.2317V67.6077C43.7754 64.5117 46.2954 61.9917 49.3914 61.9917Z"
                        fill="url(#paint1_linear_14244_10806)"
                    />

                    <path
                        d="M75.6001 85.7522C75.6001 82.5842 73.0081 79.9922 69.8401 79.9922C66.6721 79.9922 64.0801 82.5842 64.0801 85.7522C64.0801 88.9202 65.3761 89.9282 67.2481 90.8642V95.0402C67.2481 96.4802 68.4001 97.6322 69.8401 97.6322C71.2801 97.6322 72.4321 96.4802 72.4321 95.0402V90.8642C74.3041 89.9282 75.6001 87.9842 75.6001 85.7522Z"
                        fill={white}
                    />

                    <path
                        d="M75.6003 85.7519C75.6003 87.9839 74.3043 89.9279 72.4323 90.9359V95.1119C72.4323 96.5519 71.2803 97.7039 69.8403 97.7039C68.4003 97.7039 68.6163 97.4879 68.1123 97.0559C68.4003 97.1279 68.6163 97.1999 68.9043 97.1999C70.3443 97.1999 71.4963 96.0479 71.4963 94.6079V90.4319C71.8563 90.2879 72.1443 90.0719 72.4323 89.8559C73.8003 88.7759 74.6643 87.1199 74.6643 85.3199C74.6643 83.5199 73.6563 81.5759 72.1443 80.5679C74.1603 81.4319 75.6003 83.5199 75.6003 85.8239V85.7519Z"
                        fill="#70B8FF"
                    />

                    <path
                        d="M78.4082 106.344V89.5679L87.9122 106.344H78.4082Z"
                        fill="#70B8FF"
                    />

                    <path
                        d="M117.72 102.456H77.3284C75.6186 102.456 74.2324 103.842 74.2324 105.552V120.096C74.2324 121.806 75.6186 123.192 77.3284 123.192H117.72C119.43 123.192 120.816 121.806 120.816 120.096V105.552C120.816 103.842 119.43 102.456 117.72 102.456Z"
                        fill="#70B8FF"
                    />

                    <path
                        d="M81.7926 116.928L79.9206 115.776L81.7206 113.328L79.0566 112.32L79.7766 110.376L82.2246 111.744L81.9366 108.72H84.3126L84.0246 111.744L86.4726 110.376L87.1926 112.32L84.6006 113.328L86.4006 115.776L84.4566 116.928L83.1606 114.264L81.7926 116.928Z"
                        fill={white}
                    />

                    <path
                        d="M91.4411 116.928L89.5691 115.776L91.3691 113.328L88.7051 112.32L89.4251 110.376L91.8731 111.744L91.5851 108.72H93.9611L93.6731 111.744L96.1211 110.376L96.8411 112.32L94.2491 113.328L96.0491 115.776L94.1051 116.928L92.8091 114.264L91.4411 116.928Z"
                        fill={white}
                    />

                    <path
                        d="M101.017 116.928L99.1452 115.776L100.945 113.328L98.2812 112.32L99.0013 110.376L101.449 111.744L101.161 108.72H103.537L103.249 111.744L105.697 110.376L106.417 112.32L103.825 113.328L105.625 115.776L103.681 116.928L102.385 114.264L101.017 116.928Z"
                        fill={white}
                    />

                    <path
                        d="M110.665 116.928L108.793 115.776L110.593 113.328L107.929 112.32L108.649 110.376L111.097 111.744L110.809 108.72H113.185L112.897 111.744L115.345 110.376L116.065 112.32L113.473 113.328L115.273 115.776L113.329 116.928L112.033 114.264L110.665 116.928Z"
                        fill={white}
                    />

                    <path
                        d="M25.2002 135.576H118.8"
                        stroke="#70B8FF"
                        strokeWidth="3.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>

                <defs>
                    <linearGradient
                        id="paint0_linear_14244_10806"
                        x1="60.7673"
                        y1="39.7439"
                        x2="119.303"
                        y2="148.104"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#C5E2FF" />
                        <stop offset="1" stopColor="#70B8FF" />
                    </linearGradient>

                    <linearGradient
                        id="paint1_linear_14244_10806"
                        x1="50.0394"
                        y1="45.5757"
                        x2="108.575"
                        y2="153.936"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#C5E2FF" />
                        <stop offset="1" stopColor="#70B8FF" />
                    </linearGradient>

                    <clipPath id="clip0_14244_10806">
                        <rect width="144" height="144" fill={white} />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );
};

export default TwoFactorRecoveryCodesIcon;
